import React, { useEffect, useState } from 'react'
import PageLoader from '../../shared/PageLoader'
import { useAppDispatch, useAppSelector } from '../../../redux/hook';

import { 
  getAllCompaniesDetails, getAssociateCompanies, 
  getLocations, getStates 
} from '../../../redux/features/inputModule.slice';

import { 
  Box, Button, Drawer, FormControl, FormControlLabel, FormLabel, IconButton, 
  InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Radio, RadioGroup, 
  Select as MSelect, Table, TableBody, TableCell, TableContainer, TableHead, 
  TablePagination, TableRow, TableSortLabel, TextField, Typography,Chip,Checkbox 
} from '@mui/material';

import { 
  FaCheck, FaCloudDownloadAlt, FaCloudUploadAlt, 
  FaCode, FaRegEye, FaRegKeyboard, FaSortAmountDown 
} from 'react-icons/fa';

import { FaRegCircleCheck } from 'react-icons/fa6'
import { MdOutput } from "react-icons/md";
import { getBasePath } from '../../../App';
import { navigate } from 'raviger';
import axios from 'axios';
import { hasUserAccess } from '../../../backend/auth';
import { USER_PRIVILEGES } from '../UserManagement/Roles/RoleConfiguration';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getActivities, getActs,  getRules} from '../../../redux/features/inputModule.slice';
import { FaUpload, FaDownload } from "react-icons/fa";
import { IoMdAdd, IoMdClose, IoMdSearch } from "react-icons/io";
import { DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD } from '../../common/Table';
import Icon from '../../common/Icon';
import { download, downloadWithPresignedUrl, downloadFileContent, preventDefault } from '../../../utils/common';
import { ERROR_MESSAGES } from '../../../utils/constants';
import { toast } from 'react-toastify';
import { Alert } from 'react-bootstrap';
import { getLeaveConfiguration } from '../../../redux/features/leaveConfiguration.slice';
import { 
  getStateRegisterQue,
  getstateRegisterQueExcelandPdfDownloadDetails,
  getStateConfigurationDetails,
  getStateRegisterQueDownload,
  resetstateRegisterQueDetails,
  addStateRegisterQue
} from '../../../redux/features/stateRegisterQue.slice'

import { EstablishmentTypes } from '../Masters/Master.constants';
import { RxCross2 } from "react-icons/rx";
import { each } from 'underscore';
import { relative } from 'path';
import { deleteActStateMappingForm } from '../../../redux/features/Stateactruleactivitymapping.slice';

const InputsDashboard = () => {
  const dispatch: any = useAppDispatch();
  const stateRegisterQueDetails = useAppSelector((state) => state.stateRegisterQue.stateRegisterQueDetails)
  const stateRegisterQueExcelandPdfDetails = useAppSelector((state) => state.stateRegisterQue.stateRegisterQueExcelandPdfDownloadDetails)
  const companiesDetails = useAppSelector((state) => state.inputModule.companiesDetails);
  const associateCompaniesDetails = useAppSelector((state) => state.inputModule.associateCompaniesDetails);
  const locationsDetails = useAppSelector((state) => state.inputModule.locationsDetails);
  const statesDetails = useAppSelector((state) => state.inputModule.statesDetails);
  const companies = companiesDetails && companiesDetails.data.items
  const associateCompanies = associateCompaniesDetails && associateCompaniesDetails.data.items
  const locations = locationsDetails && locationsDetails.data.items
  const totalstates = statesDetails && statesDetails.data.items
  let states = locations && locations.map((each:any) => {
    const { id, name, code, city }: any = each.location || {};
    const { state } = city || {};
    return {name: state.name, id: state.id}
  })
  
  const INCLUDE_ASSOCIATION_COLUMNS = {
    company: {
      only: ['id', 'name']
    },
    associate_company: {
      only: ['id', 'name']
    },
    state: {
      only: ['id', 'name']
    },
    location: {
      only: ['id', 'name']
    },
    state_registers: {
      include: ['registers']
    }
  };
  
  const INCLUDES_ASSOCIATIONS = [
    'company','associate_company','state','location', 'state_registers'
  ];

  states = states && states.filter((each:any, index:any, self:any) => {
    if(index === self.findIndex((t:any) => t.id === each.id)){
      return each
    }
  })
  
  const [downloading,setDownloading]= useState(false);
  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);
  const styleUploadModal = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
  };

  const [company, setCompany] = React.useState('');
  const [associate_company, setAssociateCompany] = React.useState('');
  const [stateName, setStateName] = React.useState('');
  const [location, setLocation] = useState<string[]>([]);
  const [year, setYear] = React.useState('');
  const [month, setMonth] =  React.useState<any>('');
  const [establishment_type, setestablishment_type] =  React.useState<any>('');
  const [selected_locations, setSelectedLocations] = useState<any[]>([]); // Mock data for locations
  const [selectedStateRegisterQue, setSelectedStateRegisterQue] = useState<any>({});
  const [stateRegisters, setStateRegisters] = useState<any[]>([]);
  
  
  const [companyName, setCompanyName] = React.useState('');
  const [associate_company_name, setAssociateCompanyName] = React.useState('');
  const [locationName, setLocationName] = React.useState('');
    
  const [selectedStateName, setSelectedStateName] = React.useState('');

  const [showDashboardDetails, setShowDashboardDetails] = React.useState(true);
  const [queue, setQueue] = React.useState(true);
  const [queueNumbers, SetqueueNumbers] = React.useState<string[]>([]);
  
  const formsDetails = useAppSelector((state) => state.inputModule.formsDetails)
  const statesDetails2 = useAppSelector((state) => state.inputModule.statesDetails)
  const stateConfigureDetails = useAppSelector((state) => state.stateRegister.stateConfigureDetails)
  const getColumnsDetails = useAppSelector((state) => state.inputModule.getColumnsDetails);
  const addStateRegisterDetails = useAppSelector((state) => state.stateRegister.addStateRegisterDetails)
  const updateStateRegisterDetails = useAppSelector((state) => state.stateRegister.updateStateRegisterDetails)
  const deleteStateRegisterMappingDetails = useAppSelector((state) => state.stateRegister.deleteStateRegisterMappingDetails)
  const exportFile = useAppSelector(state => state.stateRegister.exportFile);
  const importStateRegisterMappingDetails = useAppSelector((state) => state.stateRegister.importStateRegisterMappingDetails);

  const companiesDetails2 = useAppSelector((state) => state.inputModule.companiesDetails);
  const associateCompaniesDetails2 = useAppSelector((state) => state.inputModule.associateCompaniesDetails);
  const locationsDetails2 = useAppSelector((state) => state.inputModule.locationsDetails);

  // console.log(formsDetails, "formsDetails")
  const stateRegisterQue = stateRegisterQueDetails.data.items
  const stateRegisterQueCount = stateRegisterQueDetails.data.meta.total_count

  const stateRegisterQueExcelandPdf = stateRegisterQueExcelandPdfDetails.data.zipObject 

  const companies2 = companiesDetails.data.items
  const associateCompanies2 = associateCompaniesDetails.data.items
  const locations2 = locationsDetails.data.items

  const statesList = statesDetails && statesDetails.data.items
  const columnsList = getColumnsDetails && getColumnsDetails.data

  const loading2 = importStateRegisterMappingDetails.status === 'loading' || 
      deleteStateRegisterMappingDetails.status === 'loading' || 
      updateStateRegisterDetails.status === 'loading' || 
      addStateRegisterDetails.status === 'loading' || 
      formsDetails.status === 'loading' || 
      stateRegisterQueDetails.status === 'loading' || 
      stateConfigureDetails.status === 'loading' || 
      getColumnsDetails.status === 'loading'

  const [stateValue, setStateValue] = React.useState('');
  const [type, setType] = React.useState('');

  const [registerType, setRegisterType] = React.useState('');
  const [processType, setProcessType] = React.useState<any>('');

  const [company1, setCompany1] = React.useState('');
  const [associate_company1, setAssociateCompany1] = React.useState('');
  const [stateName1, setStateName1] = React.useState('');
  const [location1, setLocation1] = React.useState('');
  const [year1, setYear1] = React.useState('');
  const [month1, setMonth1] = React.useState<any>('');

  const [tableData, setTableData] = React.useState<any>([]);
  const [newtableData, setnewTableData] = React.useState<any>([]);
  const [showInitialConfig, setShowInitialConfig] = React.useState<any>(false);
  const [showConfigTable, setShowConfigTable] = React.useState<any>(false);

  const [searchInput, setSearchInput] = React.useState('');
  const [activeSort, setActiveSort] = React.useState('name')
  const [sortType, setSortType] = React.useState<any>('asc')

  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [page, setPage] = React.useState(0);

  const [openAddModal, setOpenAddModal] = React.useState(false);
  const [openImportExportModal, setImportExportModal] = React.useState(false);
  const [openAddExport, setOpenAddExport] = React.useState(false)

  const [openViewModal, setOpenViewModal] = React.useState(false);
  const [selectedStateConfig, setSelectedStateConfig] = React.useState<any>({})

  const fromsList = formsDetails.data.items ? formsDetails.data.items : []
  const filteredFormsList = fromsList.filter((each: any) => each.filePath !== '' && each.formName !== '')

  const [isHovered, setIsHovered] = React.useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
    
  const loading = importStateRegisterMappingDetails.status === 'loading' || deleteStateRegisterMappingDetails.status === 'loading' || updateStateRegisterDetails.status === 'loading' || addStateRegisterDetails.status === 'loading' || formsDetails.status === 'loading' || stateRegisterQueDetails.status === 'loading' || stateConfigureDetails.status === 'loading' || getColumnsDetails.status === 'loading'
  
  const handleChangeCompany = (event:any) => {
    const selectedCompanyId = event.target.value as string;
    const selectedCompanyName = getCompanyNameById(selectedCompanyId, companies);
   // setShowDashboardDetails(false)
    setAssociateCompany('')
    setStateName('')
    setSelectedLocations([])
    setYear('')
    setMonth('')
    setCompany(event.target.value);
    setCompanyName(selectedCompanyName);
    //for table data
    setAssociateCompany1(''); setLocation1(''); setYear1(''); setMonth1(''); setCompany1(event.target.value);
    const payload: any =  { 
      filters: {
        que_id_eq: searchInput,
        company_id_eq: event.target.value
        //value : '3e8fe7a5-cc8a-4c87-8207-2d548c9bdfcf'
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(payload))
    //tabedata end
  };

  const getCompanyNameById = (id: string, companies: { id: string; name: string; }[]) => {
    for (let i = 0; i < companies.length; i++) {
      if (companies[i].id === id) {
        return companies[i].name;
      }
    }
    return '';
  };

  const handleChangeAssociateCompany = (event:any) => {
  const selectedCompanyId = event.target.value as string;
  const selectedCompanyName = getAssocCompanyNameById(selectedCompanyId, associateCompanies);
  
    //alert(selectedCompanyName);
 //   setShowDashboardDetails(false)
 setLocation([]); // Reset locations
    setYear('')
    setMonth('')
    setAssociateCompany(event.target.value);
    setAssociateCompanyName(selectedCompanyName);
    //for tabledata
    setLocation1('')
    setYear1('')
    setMonth1('')
    setAssociateCompany1(event.target.value);
    const payload: any =  { 
      filters: {
        que_id_eq: '',
        company_id_eq: company1,
        associate_company_id_eq: event.target.value
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(payload))
    //tabledata end
  };

  const getAssocCompanyNameById = (id: string, associateCompanies: { id: string; name: string; }[]) => {
    for (let i = 0; i < associateCompanies.length; i++) {
      if (associateCompanies[i].id === id) {
        return associateCompanies[i].name;
      }
    }
    return '';
  };

  const handleChangeStateName = (event:any) => {
    const selectedStateId = event.target.value as string;
    const selectedstateName = getStateNameById(selectedStateId, states);
    setSelectedStateName(selectedstateName);
  //  setShowDashboardDetails(false)
    setYear('')
    setMonth('')
    setLocation([]); // Reset locations when the state changes
    setSelectedLocations([]);
    setStateName(event.target.value);
    //for table data 
    setType('')
    setStateName1(event.target.value)
    const stateRegisterPayload: any = {
      filters: {
        que_id_eq: '',
        company_id_eq: company1,
        associate_company_id_eq: associate_company1,
        state_id_eq: event.target.value
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page + 1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(stateRegisterPayload))
    //tabel data end
  }

  const handleChangeLocation1 = (event: any) => {
    //alert(event.target.value);
    const selectedLocations = event.target.value;
    console.log(event.target.value);
    setSelectedLocations(selectedLocations); // Store selected locations as an array
    //for table data
    setYear('')
    setMonth('')
    setLocation(event.target.value);
    setLocation1(event.target.value);
    const locval = event.target.value;
    const payload: any =  { 
      filters: {
        que_id_eq: '',
        company_id_eq: company1,
        associate_company_id_eq: associate_company1,
        state_id: stateName1,
        location_id_in: event.target.value
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(payload))
  };

  const handleChangeLocation = (event:any) => {
    const selectedCompanyId = event.target.value as string;
    // alert(event.target.value);
    const selectedCompanyName = getLocationById(selectedCompanyId, locations);
    //  alert(selectedCompanyName);
    //  setShowDashboardDetails(false)
    setYear('')
    setMonth('')
    setLocation(event.target.value);
    setLocationName(selectedCompanyName);
  };

  const getLocationById = (id: string, locations: any[]) => {
    for (let i = 0; i < locations.length; i++) {
      if (locations[i].location_id === id) {
        return locations[i].location.name;
      }
    }
    return '';
  };

  const getStateNameById = (id: string, totalstates: { id: string; name: string; }[]) => {
    for (let i = 0; i < totalstates.length; i++) {
      if (totalstates[i].id === id) {
        return totalstates[i].name;
      }
    }
    return '';
  };

  
  const handleChangeYear = (event:any) => {
    //  setShowDashboardDetails(false)
    setMonth('')
    setYear(event.target.value.toString());
    //for table data
    setMonth1('')
    setYear1(event.target.value.toString());
    const payload: any =  { 
      filters: {
        que_id_eq: '',
        company_id_eq: company1,
        associate_company_id_eq: associate_company1,
        location_id_in: location1,
        year_eq: event.target.value.toString()
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(payload))
  };
  
  const handleChangeMonth = (event:any) => {
    //  setShowDashboardDetails(false)
    //alert("hitted month");
    setMonth(event.target.value);
    //for table data
    setMonth1(event.target.value);
    //const monthKey = (monthList.findIndex((each) => each === event.target.value) + 1).toString()
    const payload: any =  { 
      filters: {
        que_id_eq: '',
        company_id_eq: company1,
        associate_company_id_eq: associate_company1,
        location_id_in: location1,
        year_eq: year1,
        month_eq: event.target.value
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`],
    }
    dispatch(getStateRegisterQue(payload))
  };

  const handleChangeEstablishmentType = (event:any)=>{
    //alert(event.target.value);
    setestablishment_type(event.target.value);
    //const monthKey = (monthList.findIndex((each) => each === event.target.value) + 1).toString()
    const payload: any =  { 
      filters: {
        que_id_eq: searchInput,
        company_id_eq: company1,
        associate_company_id_eq: associate_company1,
        location_id_in: location1,
        year_eq: year1,
        month_eq: month1,
        establishment_type_eq: event.target.value
      },
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      per: rowsPerPage,
      page: page+1,
      sorts: [`state_id asc`]
    }
    dispatch(getStateRegisterQue(payload))
  }

  useEffect(() => {
    const companiesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true } }
    dispatch(getAllCompaniesDetails(companiesPayload))
  },[])

  useEffect(() => {
    const payload:any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: false, parent_company_id_eq: company } }
    if(company){
      dispatch(getAssociateCompanies(payload))
    }
  }, [company])

  useEffect(() => {
    const payload:any = {
      ...DEFAULT_OPTIONS_PAYLOAD, 
      filters: { company_id_eq: associate_company },
      includes: {
        location: { city: ['state'] }
      },
      include: {
        location: {
          only: ['id','name','code'],
          include: {
            city: {
              only: ['id','name','code'],
              include: {
                state: {
                  only: ['id','name','code']
                }
              }
            }
          }
        }
      },
      sorts: [`location_name asc`]
    }
    const statesPayload = {...DEFAULT_OPTIONS_PAYLOAD} 

    if(associate_company){
      dispatch(getLocations(payload))
      dispatch(getStates(statesPayload))
    }
  }, [associate_company])

  ///for TABLE DATA
  useEffect(() => {
    //alert("this use effect wa hitting")
    const stateRegisterQueDefaultPayload: any = {
      filters: {},
      per: 10,
      page: 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`state_id asc`],
    }
    const statesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD }
    dispatch(getStateRegisterQue(stateRegisterQueDefaultPayload))
    const companiesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true } }
    dispatch(getAllCompaniesDetails(companiesPayload))
    //dispatch(getStates(statesPayload))
  }, [])

  useEffect(() => {
   // alert("after getting company ocations");
    const payload:any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: false, parent_company_id_eq: company } }
    if(company1){
      dispatch(getAssociateCompanies(payload))
    }
  }, [company1])

  useEffect(() => {
    const payload:any = {
      ...DEFAULT_OPTIONS_PAYLOAD, 
      filters: { company_id_eq: associate_company1 },
      includes: {
        location: { city: ['state'] }
      },
      include: {
        location: {
          only: ['id','name','code'],
          include: {
            city: {
              only: ['id','name','code'],
              include: {
                state: {
                  only: ['id','name','code']
                }
              }
            }
          }
        }
      },
      sorts: [`location_name asc`]
    }
    const statesPayload = {...DEFAULT_OPTIONS_PAYLOAD} 

    if(associate_company1){
      dispatch(getLocations(payload))
      dispatch(getStates(statesPayload))
    }
  }, [associate_company1])



  useEffect(() => {
    if (stateRegisterQueDetails.status === 'succeeded') {
  //alert("this success  was hitted");
    } else if (stateRegisterQueDetails.status === 'failed') {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  }, [stateRegisterQueDetails.status])


  const handleChangePage = (event: unknown, newPage: number) => {
    const filters: any = {}
    //alert(location1);
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if (month1) {
      filters.month_eq = month1
    }
    const payload: any = {
      filters,
      per: rowsPerPage,
      page: newPage + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`state_id asc`]
    }

    dispatch(getStateRegisterQue(payload))
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const filters: any = {}
    //alert(location1);
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if (month1) {
      filters.month_eq = month1
    }
    const payload: any = {
      filters,
      per: parseInt(event.target.value, 10),
      page: 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`state_id asc`]
    }

    dispatch(getStateRegisterQue(payload))
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onClickSortCompany = () => {
    let sType = 'asc'
    setActiveSort('company_id');
    if (sortType === 'asc') {
      setSortType('desc')
      sType = 'desc'
    } else {
      setSortType('asc')
    }

    const filters: any = {}
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if(establishment_type){
      filters.establishment_type_eq = establishment_type
    }

    const Payload: any = {
      filters,
      per: rowsPerPage,
      page: page + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`company_id ${sType}`]
    }
    dispatch(getStateRegisterQue(Payload))
  }

  const onClickSortAssociateCompany = () => {
    let sType = 'asc'
    setActiveSort('associatecompany_id');
    if (sortType === 'asc') {
      setSortType('desc')
      sType = 'desc'
    } else {
      setSortType('asc')
    }

    const filters: any = {}
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if(establishment_type){
      filters.establishment_type_eq = establishment_type
    }

    const Payload: any = {
      filters,
      per: rowsPerPage,
      page: page + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`associate_company_id ${sType}`]
    }
    dispatch(getStateRegisterQue(Payload))
  }

  const onClickSortLocation = () => {
    let sType = 'asc'
    setActiveSort('location_id');
    if (sortType === 'asc') {
      setSortType('desc')
      sType = 'desc'
    } else {
      setSortType('asc')
    }

    const filters: any = {}
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if(establishment_type){
      filters.establishment_type_eq = establishment_type
    }

    const Payload: any = {
      filters,
      per: rowsPerPage,
      page: page + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`location_id ${sType}`]
    }
    dispatch(getStateRegisterQue(Payload))

  }

  const onClickSortYear = () => {
    let sType = 'asc'
    setActiveSort('');
    if (sortType === 'asc') {
      setSortType('desc')
      sType = 'desc'
    } else {
      setSortType('asc')
    }

    const filters: any = {}
    if (searchInput) {
      filters.que_id_eq = searchInput
    }
    if (company1) {
      filters.company_id_eq = company1
    }
    if (associate_company1) {
      filters.associate_company_id_eq = associate_company1
    }
    if (location1) {
      filters.location_id_in = location1
    }
    if (year1) {
      filters.year_eq = year1
    }
    if (month1) {
      filters.month_eq = month1
    }
    if(establishment_type){
      filters.establishment_type_eq = establishment_type
    }

    const Payload: any = {
      filters,
      per: rowsPerPage,
      page: page + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`company_id ${sType}`]
    }
    dispatch(getStateRegisterQue(Payload))

  }


                //table data end

  const yearsList = []
  const currentYear = new Date().getFullYear();

  for (let i = currentYear; i >= 1950; i--) {
    yearsList.push(i)
  }

  const monthList = [
    "January",
    "February",
    "March",  
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const EstablishmentTypesList = [
    "BOCW",
    "CLRA",
    "Factory",  
    "ISM",
    "Shops"
  ];

  const handleProcessRegisters = async () => {
    setDownloading(true);
    let newQueueNumbers: string[] = [];
    try {
      for (const location of selected_locations) {
        // alert("hitted que"+location)
        const payload = {
          company_id: company,
          associate_company_id: associate_company,
          location_id: location,
          state_id: stateName,
          year: year,
          month: month,
          establishment_type: establishment_type,
        };
        const resultAction = await dispatch(addStateRegisterQue(payload))
        if(addStateRegisterQue.fulfilled.match(resultAction)) {
          console.log('✅ Update successful:', resultAction.payload);
          newQueueNumbers.push(resultAction.payload.data.que_id); // Add QueId to the temporary list
        } else {
          console.error('❌ Update failed:', resultAction.payload);
        }
      }
      // Update the state with the new queue numbers
      SetqueueNumbers((prevQueueNumbers) => [...prevQueueNumbers, ...newQueueNumbers]);
      console.log(queueNumbers);
      // Step 3: Display the QueueNo list to the user in a popup
      if (newQueueNumbers.length > 0) {
        alert(`Queue Numbers received : \n${newQueueNumbers.join(", ")}`);
        const payload: any =  { 
          filters: {
            que_id_eq: '',
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            location_id_in: location,
            year_eq: year,
            month_eq: month,
            establishment_type_eq: establishment_type
          },
          per: rowsPerPage,
          page: page+1,
          include: INCLUDE_ASSOCIATION_COLUMNS,
          includes: INCLUDES_ASSOCIATIONS,
          sorts: [`state_id asc`]
        }
        dispatch(getStateRegisterQue(payload))

      } else {
        toast.error('No Queue Numbers found.');
      }
      setDownloading(false);
    } catch (error) {
      console.error("Error processing registers:", error);
      alert("An error occurred while processing the registers.");
      setDownloading(false); // Reset the downloading state even if there's an error
    }
  };

  interface FileDetails {
    filePath: string;
    configType: string;
  }
  
  interface ApiResponse {
    status: string;
    list: FileDetails[];
    message: string | null;
  }

  const onClickDownloadZip = (url:any) => {
    if(url) {
      downloadWithPresignedUrl(url.split('/').pop(), url)
    } else {
      toast.info("No URL found");
    }
  }

  const onclickDownloadExcel=(file:any)=>{
    console.log(file);
    const url = file.register_excel_url || '';
    if (url) {
      downloadWithPresignedUrl(url.split('/').pop(), url);
    } else {
      toast.info("No URL found");
      return "No URL found";
    }
  }

  const onclickDownloadPdf=(file:any)=>{
    console.log(file);
    const url = file.register_pdf_url || '';
    if (url) {
      downloadWithPresignedUrl(url.split('/').pop(), url);
    } else {
      toast.info("No URL found");
      return "No URL found";
    }
  }

  // Function to handle the download of all files
  const handleFileDownloads = async (files: FileDetails[]) => {
    for (const file of files) {
     // alert(file.filePath);
      await onclickDownloadExcel(file);
    }
  };

  const onclickDownloadBoth=(each :any)=>{
    setOpenDownloadModal(true);
    console.log(each);
    /*
    const Payload: any =  { 
      company_id: each.company_id,
      associate_company_id:  each.associate_company_id,
      location_id: each.location_id,
      state_id: each.state_id, 
      year: each.year, 
      month: each.month,
      establishment_type : each.establishment_type,
      zipType : "ExcelZip"
    }
    */
    //dispatch(getstateRegisterQueExcelandPdfDownloadDetails(Payload))
    setSelectedStateRegisterQue(each);
    const _stateRegisters = each.state_registers || [];
    const updatedStateRegisters: any = [];
    _stateRegisters.forEach((_stateRegister: any) => {
      const _registers = [...(_stateRegister.registers || [])].sort((a: any, b: any) => Number(a.id) - Number(b.id));
      if(_registers.length > 1) {
        updatedStateRegisters.push(
          ..._registers.map((register: any, index: number) => {
            return {
              ..._stateRegister,
              form_name: _stateRegister.form_name + ` Part - ${index + 1}`,
              register_excel_url: register.excel_url || '',
              register_pdf_url: register.pdf_url || ''
            }
          })
        );
      } else {
        updatedStateRegisters.push({
          ..._stateRegister,
          register_excel_url: (_registers[0] || {}).excel_url || '',
          register_pdf_url: (_registers[0] || {}).pdf_url || ''
        });
      }
    });
    setStateRegisters(updatedStateRegisters);
  }

  function formatDate(timestamp : any) {
    const date = new Date(timestamp);
    
    // Extract date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    // Extract time components
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Combine date and time in the desired format
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const handleChangeSearchInput = (event: any) => {
    setSearchInput(event.target.value)
  }

  const onClickClearSearch = () => { 
    const filters: any = {}
    filters.id_eq = ''
    filters.company_id_eq = company
    filters.associate_company_id_eq = associate_company
    filters.location_id_in = location
    filters.year_eq = year
    filters.month_eq = month
    filters.establishment_type_eq = establishment_type

    const employeesPayload: any = {
      filters: filters,
      per: rowsPerPage,
      page: page + 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`code asc`]
    }
    dispatch(getStateRegisterQue(employeesPayload))
    setSearchInput('')
  }

  const onClickSearch = () => {
    const employeesPayload: any = {
      filters: {
        que_id_eq: searchInput
      },
      per: rowsPerPage,
      page: 1,
      include: INCLUDE_ASSOCIATION_COLUMNS,
      includes: INCLUDES_ASSOCIATIONS,
      sorts: [`code asc`]
    }
    dispatch(getStateRegisterQue(employeesPayload))
    setPage(0);
  }

  return (
    <div style={{ backgroundColor:'#ffffff', minHeight:'100vh'}}>
      {/* Upload Modal */}
      <Modal
        open={openDownloadModal}
        onClose={() => {setDownloading(false)}}
      >
        <Box sx={styleUploadModal}>
          <Box sx={{backgroundColor:'#E2E3F8', padding:'10px', px:'20px', borderRadius:'6px', boxShadow: '0px 6px 10px #CDD2D9', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <Typography sx={{font: 'normal normal normal 32px/40px Calibri'}}>Excel & Pdf Download</Typography>
            <IconButton
              onClick={() => {setOpenDownloadModal(false);}}
            >
              <IoMdClose />
            </IconButton>
          </Box>

          <TableContainer sx={{ border: '1px solid #e6e6e6', marginTop: '10px', maxHeight: '385px', overflowY: 'scroll' }}>
              <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                <TableHead sx={{ '.MuiTableCell-root': { backgroundColor: '#E7EEF7',fontWeight:'600' } }}>
                  <TableRow>
                    {/* <TableCell><Checkbox/></TableCell> */}
                    <TableCell > <TableSortLabel active={activeSort === 'company_id'} direction={sortType} onClick={onClickSortCompany}>FormName</TableSortLabel></TableCell>
                    <TableCell > 
                      <TableSortLabel active={activeSort === 'associate_company_id'} direction={sortType} onClick={onClickSortAssociateCompany}>Download Excel</TableSortLabel>
                    </TableCell>
                    <TableCell >Download Pdf</TableCell>
                    <TableCell >First Generated Date</TableCell>
                    <TableCell >Last Generated Date</TableCell>
                    <TableCell >Total Generations</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>

                  {stateRegisters && stateRegisters.map((each: any, index: number) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      {/* <TableCell><Checkbox/></TableCell> */}
                      <TableCell >{each.form_name ? each.form_name : 'NA'}</TableCell>
                      <TableCell >
                        <Box sx={{ display: 'flex',justifyContent: "center" }}>
                          {each.register_excel_url && <Icon 
                              style={{ color: '#0654AD' }} 
                              type="button" 
                              name={'download'} 
                              text={'download'}  
                              action={() => onclickDownloadExcel(each)}
                          />}
                        </Box>
                      </TableCell>
                      
                      <TableCell >
                        <Box sx={{ display: 'flex',justifyContent: "center" }}>
                          {each.register_pdf_url && <Icon 
                              style={{ color: '#0654AD' }} 
                              type="button" 
                              name={'download'} 
                              text={'download'}  
                              action={() => onclickDownloadPdf(each)}
                          />}
                        </Box>
                      </TableCell>
                      <TableCell >{formatDate(each.created_at)}</TableCell>
                      <TableCell >{formatDate(each.updated_at)}</TableCell>
                      <TableCell >{each.count}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          <Box sx={{display:'flex', padding:'20px', borderTop:'1px solid #6F6F6F',justifyContent:'flex-end', alignItems:'center', mt:4}}>
            <Button variant='contained' sx={{backgroundColor:'#707070',mr:10}} onClick={() => {onClickDownloadZip(selectedStateRegisterQue.register_url)}}>Download Excel Zip</Button>
            <Button variant='contained' sx={{backgroundColor:'#707070',mr:10}} onClick={() => {onClickDownloadZip(selectedStateRegisterQue.pdf_register_url)}}>Download PDF Zip</Button>
            <Button variant='contained' sx={{backgroundColor:'#707070'}} onClick={() => {setOpenDownloadModal(false)}}>Cancel</Button>
          </Box>
        </Box>
      </Modal>
      {loading ? <PageLoader>Loading...</PageLoader> : 
      <div>
        {downloading ? <PageLoader>Processing Registers...</PageLoader> :

        <div style={{paddingBottom:'100px'}}>

            {/* Filter Box*/}
            <Box sx={{paddingX: '20px', paddingY:'10px',}}>
              <div style={{backgroundColor:'#E2E3F8', padding:'20px', borderRadius:'6px', boxShadow: '0px 6px 10px #CDD2D9'}}>
                  <div style={{display:'flex', justifyContent:'space-between', marginBottom:'15px', marginTop:'10px'}}>
                    <h5 style={{ font: 'normal normal normal 32px/40px Calibri' }}>Que Registers</h5>
                    <FormControl sx={{ width: '20%', backgroundColor: '#ffffff', borderRadius: '5px', height: '100%' }} size="small">                      
                    <InputLabel htmlFor="outlined-adornment-search">Search Que No</InputLabel>
                    <OutlinedInput
                      value={searchInput}
                      onChange={handleChangeSearchInput}
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      id="outlined-adornment-search"
                      type='text'
                      label="Search Que No"

                      endAdornment={
                        <InputAdornment position="end">
                          {searchInput &&
                            <IconButton
                              onClick={onClickClearSearch}
                              edge="end"
                            >
                              <IoMdClose />
                            </IconButton>
                          }
                          <IconButton
                            onClick={onClickSearch}
                            edge="end"
                          >
                            <IoMdSearch />
                          </IconButton>
                        </InputAdornment>
                      }
                    />             
                    </FormControl>
                  </div>
               
                  <div style={{display:'flex'}}>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          value={company}
                          displayEmpty
                      onChange={handleChangeCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Company
                          </MenuItem>
                          {companies && companies.map((each:any) => {
                              return <MenuItem sx={{width:'240px', whiteSpace:'initial'}} value={each.id}>{each.name}</MenuItem>
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Associate Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={associate_company}
                          disabled={!company}
                      onChange={handleChangeAssociateCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Associate Company
                          </MenuItem>
                          {associateCompanies && associateCompanies.map((each:any) => {
                            return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>States</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={stateName}
                          disabled={!associate_company}
                      onChange={handleChangeStateName}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select State
                          </MenuItem>
                          {states && states.map((each:any) => {
                            return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Location</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                      <MSelect
                        sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                        displayEmpty
                        value={selected_locations}
                        multiple // Enable multiple selection
                        disabled={!stateName}
                        onChange={handleChangeLocation1}
                        input={<OutlinedInput />}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)' }}>Select Location</Typography>;
                          }
                          return (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, "& .MuiChip-root": { height: "100%" } }}>
                              {selected.map((value: string) => {
                                // Find the selected location by its ID
                                const selectedLocation = locations.find((loc: any) => loc.location_id === value);
                                // Display the location name if found
                                return selectedLocation ? <Chip key={value} label={selectedLocation.location.name} /> : null;
                              })}
                            </Box>
                          );
                        }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Location
                          </MenuItem>
                          {locations && locations.map((each:any) => {
                            const { id, name, code, city }: any = each.location || {};
                            const { state } = city || {};
                            if(state.id === stateName){
                              return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.location_id}>{`${name} (${state.code}-${city.code}-${code})`}</MenuItem>
                            }
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Year</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={year}
                          disabled={!location}
                      onChange={handleChangeYear}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 150,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Year
                          </MenuItem>
                          {yearsList && yearsList.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Month</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={month}
                          disabled={!year}
                      onChange={handleChangeMonth}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 150,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Month
                          </MenuItem>
                          {monthList && monthList.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </MSelect>
                      </FormControl>
                    </Box>
                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>EstablishmentType</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={establishment_type}
                          disabled={!month}
                      onChange={handleChangeEstablishmentType}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 150,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Type
                          </MenuItem>
                          {EstablishmentTypesList && EstablishmentTypesList.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </MSelect>
                      </FormControl>
                    </Box>
                  </div>
              </div>
            </Box>
            {/* Status Box */}
            {showDashboardDetails && 
              <Box sx={{paddingX: '20px', color:'#F3F4F8', mt:2, }}>
                <Box sx={{display:'flex', justifyContent:'center', width:'100%', padding:'15px', background:'#EFEBFE 0% 0% no-repeat padding-box', boxShadow:'0px 6px 10px #00000029', borderRadius:'8px'}}>
                {
                  hasUserAccess(USER_PRIVILEGES.REGISTER_GENERATION_QUE) &&
                  <Button sx={{my:2, width:'90%'}} variant='outlined' onClick={handleProcessRegisters} disabled={ !company || !associate_company || !stateName || !selected_locations || !year || !month || !establishment_type   }>
                  {/* <Typography padding={'8px'} color={'#0654AD'}> Process Registers</Typography> */}
                  Generate Registers
                  </Button>
                }
                </Box>
              </Box>
            }
            <Box sx={{ paddingX: '20px' }}>
            {
              stateRegisterQue && stateRegisterQue.length <= 0 ?
                <Box sx={{ height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Typography variant='h5'>No Records Found</Typography>
                </Box>
                :
                <>
                  <TableContainer sx={{ border: '1px solid #e6e6e6', marginTop: '26px', maxHeight: '385px', overflowY: 'scroll', borderRadius: '8px 8px 0px 0px' }}>
                    <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                      <TableHead sx={{ '.MuiTableCell-root': { backgroundColor: '#E7EEF7',fontWeight:'600' } }}>
                        <TableRow>
                          {/* <TableCell><Checkbox/></TableCell> */}
                          <TableCell > <TableSortLabel active={activeSort === 'company_id'} direction={sortType} onClick={onClickSortCompany}>Company</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'associate_company_id'} direction={sortType} onClick={onClickSortAssociateCompany}>AssociateCompany</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'state_id'} direction={sortType} onClick={onClickSortLocation}>State</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'location_id'} direction={sortType} onClick={onClickSortLocation}>Location</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'location_id'} direction={sortType} onClick={onClickSortLocation}>Year</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'location_id'} direction={sortType} onClick={onClickSortLocation}>Month</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'year'} direction={sortType} onClick={onClickSortYear}>Que Id</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'year'} direction={sortType} onClick={onClickSortYear}>Que Status</TableSortLabel></TableCell>
                          <TableCell >Download</TableCell>
                          <TableCell >Created Date</TableCell>
                          <TableCell >Last Updated</TableCell>
                          {/* <TableCell >Completed Date</TableCell> */}

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stateRegisterQue && stateRegisterQue.map((each: any, index: number) => (
                          <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            {/* <TableCell><Checkbox/></TableCell> */}
                            <TableCell >{each.company && each.company.name ? each.company.name : 'NA'}</TableCell>
                            <TableCell >{each.associate_company && each.associate_company.name ? each.associate_company.name : 'NA'}</TableCell>
                            <TableCell >{each.state && each.state.name ? each.state.name : 'NA'}</TableCell>
                            <TableCell >{each.location && each.location.name ? each.location.name : 'NA'}</TableCell>

                            <TableCell >{each.year && each.year ? each.year : 'NA'}</TableCell>
                            <TableCell >{each.month && each.month ? each.month : 'NA'}</TableCell>
                            <TableCell >{each.que_id && each.que_id ? each.que_id : 'NA'}</TableCell>
                            <TableCell >{each.que_status && each.que_status ? each.que_status : 'NA'}</TableCell>
                            <TableCell >
                            <Box sx={{ display: 'flex',justifyContent: "center" }}>
                              {each.que_status === 'pdf_processing_partially_completed' || each.que_status === 'pdf_processing_completed' ? (
                                <Icon 
                                    style={{ color: '#0654AD', opacity: 1, pointerEvents: 'auto' }} 
                                    type="button" 
                                    name={'download'} 
                                    text={'download'} 
                                    action={() => onclickDownloadBoth(each)} 
                                />
                              ): (
                                <Icon
                                  style={{ color: '#0654AD', opacity: 0.5, pointerEvents: 'none' }}
                                  name={'download'}
                                  text={'download'}
                                />
                              )
                              }
                            </Box>
                            </TableCell>
                            <TableCell >{each.created_at && formatDate(each.created_at) ? formatDate(each.created_at) : 'NA'}</TableCell>
                            <TableCell >{each.completed_date && formatDate(each.completed_date) ? formatDate(each.completed_date) : 'NA'}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    sx={{
                      borderRadius: '0px 0px 8px 8px',
                      '.MuiTablePagination-toolbar': {
                        backgroundColor: '#EFEBFE',
                        height: '30px',
                        display: 'flex',
                        justifyContent: 'flex-end'
                      },
                      '.MuiTablePagination-displayedRows': {
                        margin: '0',
                      },
                      '.MuiTablePagination-selectLabel': {
                        margin: '0',
                      },
                      '.MuiTablePagination-spacer': {
                        display: 'none '
                      },
                      '.MuiTablePagination-input': {
                        marginRight: 'auto'
                      },
                    }}

                    labelRowsPerPage='Show'
                    labelDisplayedRows={(page) =>
                      `Showing ${page.from}-${page.to === -1 ? page.count : page.to} of ${page.count}`
                    }
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={stateRegisterQueCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
            }
          </Box>
        </div>
        }
     </div>
    }
    </div>
  )
}
export default InputsDashboard
